export default {
  list: {
    title: "Driverlar",
    newDriver: "Yangi driver",
    scope: { recruiter: "Mening driverlarim", branch_manager: "Filial driverlari", owner: "Barcha driverlar" },
    filters: { stageMonth: "Oyda bosqich", stageAdded: "Qo'shilgan", month: "Oy",
      driverType: "Driver turi",
      freight: "Yuk turi",
      source: "Manba",
      state: "Shtat",
      cdlClass: "CDL sinfi",
      classN: "{{cls}} sinf",
      dateAdded: "Qo'shilgan sana",
      recruiter: "Recruiter",
      allRecruiters: "Barcha recruiterlar",
      legalStatus: "Legal status",
      problem: "Muammo",
    },
    dateAdded: {
      today: "Bugun",
      d7: "Oxirgi 7 kun",
      d30: "Oxirgi 30 kun",
      d90: "Oxirgi 90 kun",
      d180: "Oxirgi 180 kun",
      y1: "Oxirgi 1 yil",
      older90d: "90 kundan oldin",
      older180d: "180 kundan oldin",
      older1y: "1 yildan oldin",
      custom: "Oraliq (Dan – Gacha)…",
      from: "Dan",
      to: "Gacha",
    },
    problem: { any: "Har qanday muammo", incomplete: "Profil to'liq emas", docs_missing: "Majburiy hujjat yo'q", docs_expiring: "Hujjat muddati tugayapti", docs_expired: "Hujjat muddati tugagan", overdue_reminder: "Eslatma muddati o'tgan", no_contact: "Uzoq bog'lanilmagan", stale: "Bosqichda qotib qolgan", unassigned: "Recruiteri yo'q" },
    search: "Qidiruv:",
    chips: { all: "Hammasi", lost: "Yo'qotilgan" },
    empty: {
      filteredTitle: "Bu filtrlarga mos driver yo'q",
      filteredHint: "Filtrni olib tashlang yoki telefon bo'yicha qidiring.",
      title: "Hali driver yo'q",
      hint: "Birinchi driverni qo'shing yoki Google Sheets'dan import qiling.",
    },
    selectAll: "Hammasini tanlash",
    selectOne: "{{name}} ni tanlash",
    cols: {
      carrier: "Carrier",
      name: "Ism",
      phone: "Telefon",
      state: "Shtat",
      cdl: "CDL / tajriba",
      status: "Holat",
      source: "Manba",
      owner: "Egasi",
      lastContact: "Oxirgi aloqa",
      nextAction: "Keyingi ish",
    },
    pool: "Pool",
    pagLabel: "driver",
    next: {
      reason: "Sabab: {{reason}}",
      firstCall: "Birinchi qo'ng'iroq",
      waitingCarrier: "Carrier kutilmoqda",
      overdueToday: "{{label}} · bugun kechikdi",
      overdueDays_one: "{{label}} · {{count}} kun kechikdi",
      overdueDays_other: "{{label}} · {{count}} kun kechikdi",
    },
  },
  statusModal: {
    title: "Holatni o'zgartirish",
    now: "{{name}} · hozir {{status}}",
    newStatus: "Yangi holat",
    select: "Tanlang…",
    pipeline: "Pipeline",
    lost: "Yo'qotilgan",
    current: "(joriy)",
    job: "Vakansiya / carrier",
    jobHint: "Faqat ochiq vakansiyalar ko'rsatiladi.",
    docsMissing: "Hali yo'q hujjatlar: {{names}}.",
    docsBlocked: "Ular yuklanmaguncha topshirib bo'lmaydi (Sozlamalar → Hujjatlar).",
    loading: "Yuklanmoqda…",
    startDate: "Boshlash sanasi",
    reason: "Sabab",
    note: "Izoh",
    notePlaceholderHired: "Dalil: carrier email orqali tasdiqladi, orientation o'tdi…",
    optional: "Ixtiyoriy",
    hiredNote: "Hired menejer tasdig'idan keyin hisoblanadi (Approvals).",
    submittedNote: "Tanlangan vakansiya uchun ariza yaratiladi va driver tarixiga yoziladi.",
    errors: {
      chooseStatus: "Holatni tanlang.",
      jobRequired: "Vakansiya / carrier majburiy.",
      chooseJob: "Vakansiya (carrier) tanlang.",
      startDate: "Boshlash sanasi majburiy.",
      reason: "Sabab majburiy.",
    },
    updated: "Holat yangilandi",
    changedBy: "{{who}} o'zgartirdi. Qayta yuklandi.",
    someoneElse: "Boshqa foydalanuvchi",
    reloadedHint: "Joriy holatni ko'rib chiqing va qayta urining.",
    failed: "Holatni o'zgartirib bo'lmadi",
  },
  form: {
    contact: "Aloqa",
    firstName: "Ism",
    lastName: "Familiya",
    phone: "Telefon",
    noPhoneWarning: "Telefon kiritilmagan — qo'ng'iroq va takrorni tekshirish ishlamaydi.",
    driverType: "Driver turi",
    freight: "Yuk turi",
    phoneHint: "Istalgan format, masalan (555) 010-0142",
    email: "Email",
    state: "Shtat",
    select: "Tanlang…",
    city: "Shahar",
    secondaryPhone: "Qo'shimcha telefon",
    legalStatus: "Legal status",
    dob: "Tug'ilgan sana",
    dobHint: "Recruiterlarga yashirin ko'rsatiladi",
    cdlMedical: "CDL va tibbiy karta",
    cdlClass: "CDL sinfi",
    cdlState: "CDL shtati",
    cdlNumber: "CDL raqami",
    cdlNumberHint: "Dublikat uchun ham tekshiriladi",
    cdlNumberPlaceholder: "masalan 12345678",
    managedByManager: "Menejeringiz boshqaradi",
    cdlExpires: "CDL muddati",
    medicalExpires: "Tibbiy karta muddati",
    endorsements: "Endorsementlar",
    experienceTitle: "Tajriba va afzalliklar",
    experience: "Tajriba",
    years: "yil",
    months: "oy",
    drivingType: "Haydash turi",
    equipment: "Texnika",
    homeTime: "Uyga qaytish",
    desiredPay: "Kutilgan maosh",
    desiredPayPlaceholder: "$1,400 / hafta",
    availableFrom: "Boshlashga tayyor",
    sourceTitle: "Manba",
    source: "Manba",
    referredBy: "Kim tavsiya qildi",
    referredByPlaceholder: "Faqat Referral uchun",
    owner: "Egasi",
    ownerHint: "Bo'sh = filial pooli, menejer biriktiradi",
    pool: "Filial pooli (biriktirilmagan)",
    notes: "Izohlar",
    notesPlaceholder: "Birinchi qo'ng'iroq izohlari, afzalliklar...",
    validation: {
      required: "Majburiy",
      phone: "To'g'ri telefon raqam kiriting",
      email: "To'g'ri email kiriting",
      years: "0–40",
      months: "0–11",
      duplicate: "Bazada allaqachon bor",
    },
  },
  dup: {
    phoneSecondary: "Qo'shimcha telefon",
    email: "Email",
    sameName_one: "Bazada shu ismli {{count}} ta driver bor:",
    sameName_other: "Bazada shu ismli {{count}} ta driver bor:",
    scamShort: "⚠ SCAM ({{date}} dan)",
    confirm: "Bu boshqa odam — baribir qo'shish",
    scam: "⚠ SCAM: bu driver {{date}} da firibgar (scam) deb belgilangan.",
    scamBy: "Belgilagan: {{name}}",
    lost: "{{status}} — {{date}} · sabab: {{reason}}.",
    reopenHint: "Profilni ochib, {{a}} yoki {{b}} qilib qayta oching — tarix saqlanadi.",
    title: "Dublikat bo'lishi mumkin.",
    phone: "Telefon {{phone}}",
    cdl: "CDL raqami",
    belongsTo: "tegishli:",
    owner: "egasi {{name}}",
    unassigned: "biriktirilmagan (pool)",
    assignedUntil: "{{date}} gacha biriktirilgan",
    open: "Profilni ochish",
    askTransfer: "Menejerdan o'tkazishni so'rash",
  },
  new: {
    breadcrumb: "Driverlar",
    title: "Yangi driver",
    added: "Driver qo'shildi",
    addedDesc: "{{name}} endi New holatida.",
    checkFields: "Belgilangan maydonlarni tekshiring",
    saveFailed: "Driverni saqlab bo'lmadi",
    transferNote: "Driver qo'shishda dublikat topildi",
    requestSent: "So'rov menejeringizga yuborildi",
    requestSentDesc: "Qaror qabul qilinganda xabar beriladi.",
    requestFailed: "So'rovni yuborib bo'lmadi",
    you: "siz",
    selectedRecruiter: "tanlangan recruiter",
    pool: "filial pooli (biriktirilmagan)",
    ownerAfter: "Saqlangandan keyin egasi:",
    assignedFor: "{{days}} kunga biriktiriladi ({{until}} gacha)",
    required: "majburiy",
    save: "Driverni saqlash",
  },
  profile: {
    noPhone: "Telefon yo'q",
    tabs: {
      overview: "Umumiy",
      applications: "Arizalar ({{n}})",
      activity: "Faollik ({{n}})",
      documents: "Hujjatlar {{n}}/{{total}}",
      history: "Tarix",
    },
    approvedBy: "{{name}} tasdiqladi",
    manager: "menejer",
    pendingApproval: "menejer tasdig'i kutilmoqda",
    source: "Manba: {{source}}",
    owner: "Egasi:",
    pool: "filial pooli (biriktirilmagan)",
    assignedUntil: "{{date}} gacha biriktirilgan",
    added: "qo'shilgan {{date}}",
    submitToJob: "Vakansiyaga yuborish",
    logCall: "Qo'ng'iroq yozish",
    changeStatus: "Holatni o'zgartirish",
    hero: { call: "Qo'ng'iroq", note: "Izoh", moveTo: "Keyingi: {{stage}}", more: "Boshqa amallar" },
    nextStep: { title: "Keyingi qadam", overdue: "kechikkan", markDone: "Bajarildi", none: "Keyingi qadam yo'q. Driver unutilmasligi uchun eslatma qo'shing." },
    stageBar: { label: "Bosqich", hint: "Dastakni suring yoki bosqich nomini bosing -- driver o'sha bosqichga o'tadi", notAllowed: "Bu bosqichdan o'tib bo'lmaydi", saving: "Saqlanmoqda…" },
    daysInStage_one: "shu bosqichda {{count}} kun",
    daysInStage_other: "shu bosqichda {{count}} kun",
    applications: "Arizalar ({{n}})",
    details: {
      phone: "Telefon",
      email: "Email",
      owner: "Egasi",
      added: "Qo'shilgan",
      driverType: "Driver turi",
      freight: "Yuk turi",
      title: "Driver ma'lumotlari",
      fullName: "To'liq ism",
      dob: "Tug'ilgan sana",
      cdl: "CDL",
      classN: "{{cls}} sinf",
      hideCdl: "CDL raqamini yashirish",
      showCdl: "CDL raqamini ko'rsatish",
      cdlExpires: "CDL muddati",
      medicalExpires: "Tibbiy karta muddati",
      expired: "⚠ {{days}} kun oldin tugagan",
      expiresIn: "⚠ {{days}} kundan keyin tugaydi",
      experience: "Tajriba",
      year_one: "{{count}} yil",
      year_other: "{{count}} yil",
      endorsements: "Endorsementlar",
      equipment: "Texnika",
      preferences: "Afzalliklar",
      home: "Uyga {{value}}",
      availableFrom: "Boshlashga tayyor",
      secondaryPhone: "Qo'shimcha telefon",
      legalStatus: "Legal status",
      referredBy: "Kim tavsiya qildi",
      notes: "Izohlar",
      importedFrom: "Import manbasi",
    },
    retention: {
      title: "Ushlab qolish",
      subtitle: "{{job}} · {{carrier}} · boshlagan {{date}}",
      confirmedChip: "{{days}} kun · {{date}}",
      confirmed: "{{days}} kunlik ushlab qolish tasdiqlandi",
      confirm: "{{days}} kunni tasdiqlash",
      due: "muddati {{date}}",
      dueTitle: "Muddati {{date}}",
    },
    apps: {
      payment: "To'lov",
      empty: "Hali ariza yo'q. Driverni vakansiyaga yuboring.",
      job: "Vakansiya",
      carrier: "Carrier",
      status: "Holat",
      date: "Sana",
      submitted: "Yuborilgan",
      by: "Kim",
      reply: "Carrier javobi",
      decided: "Qaror",
      rejected: "Rad etildi · {{reason}}",
      start: "boshlash {{date}}",
    },
    activity: {
      title: "Faollik",
      addReminder: "Eslatma qo'shish",
      type: "Faollik turi",
      types: { note: "Izoh", call: "Qo'ng'iroq", sms: "SMS", email: "Email", status: "Holat", system: "Tizim" },
      system: "Tizim",
      created: "Yaratildi",
      callMins: "Qo'ng'iroq, {{mins}} daq",
      min: "daq",
      duration: "Davomiyligi, daqiqa",
      outcome: "Natija",
      outcomes: { answered: "Javob berdi", no_answer: "Javob yo'q", voicemail: "Ovozli pochta", busy: "Band" },
      placeholderCall: "Qo'ng'iroq qanday o'tdi?",
      placeholderNote: "Izoh qo'shing yoki qo'ng'iroqni yozing...",
      callLogged: "Qo'ng'iroq yozildi",
      nextReminder: "Keyingi eslatma:",
      overdue: "kechikdi",
      tomorrow: "Ertaga",
      reminderDone: "Eslatma bajarildi",
      noPending: "Kutilayotgan eslatma yo'q.",
      loading: "Faollik yuklanmoqda…",
      empty: "Hali faollik yo'q.",
      emptyTitle: "Hali faollik yo'q",
      showAll: "Barcha faollikni ko'rsatish ({{n}}) →",
      page: "{{page}}-sahifa / {{pages}}",
    },
    reminder: {
      title: "Eslatma qo'shish",
      chooseDateTime: "Sana va vaqtni tanlang.",
      added: "Eslatma qo'shildi",
      failed: "Eslatmani qo'shib bo'lmadi",
      type: "Turi",
      date: "Sana",
      time: "Vaqt",
      timeHint: "Driver vaqti ({{tz}})",
      assignTo: "Kimga",
      driversOwner: "Driver egasi",
      note: "Izoh",
      notePlaceholder: "Tajriba tafsilotlarini aniqlashtirish",
    },
    history: { when: "Qachon", change: "O'zgarish", reason: "Sabab / izoh", job: "Vakansiya", by: "Kim" },
    edit: {
      title: "{{name}} ni tahrirlash",
      desc: "O'zgarishlar audit logga yoziladi.",
      updated: "Driver yangilandi",
      conflictDesc: "O'zgarishlaringiz saqlanmadi. Yangi qiymatlarni tekshirib, qayta urining.",
      checkFields: "Belgilangan maydonlarni tekshiring",
    },
  },
};
